/**
 * Logo Header Component
 *
 * A minimal header that shows just the centered Cosimo logo.
 * Use in overlays, sheets, and fullscreen modes where the
 * full navbar isn't needed but branding should be visible.
 */
"use client";

import { colors } from "@/styles/design-tokens";

import { LogoContainer } from "./LogoContainer";

interface LogoHeaderProps {
  showBorder?: boolean;
  backgroundColor?: string;
  className?: string;
}

export function LogoHeader({
  showBorder = true,
  backgroundColor = colors.background.white,
  className = "",
}: LogoHeaderProps) {
  return (
    <div
      className={`flex flex-shrink-0 items-center justify-center px-4 py-3 ${className}`}
      style={{
        backgroundColor,
        borderBottom: showBorder ? `1px solid ${colors.divider.default}` : "none",
      }}
    >
      <LogoContainer />
    </div>
  );
}
